// extracted by mini-css-extract-plugin
export default {"row":"EventOfferFixedPriceTicketType_row__zxuq4","wrapper":"EventOfferFixedPriceTicketType_wrapper__VzxhX","item":"EventOfferFixedPriceTicketType_item__8aH6M"};